export const CUSTOMERSIGNUP = '/'
export const CUSTOMERSIGNUP1 = '/customersignup'
export const FORGOTPASSWORD = '/forgotpassword'
export const RESETPASSWORD = '/resetpassword'
export const VERIFICATION = '/verification'
export const LOGIN = '/customerlogin'
export const POSITIONS = '/positions'
export const CONTRACTRESOURCES = '/contractresources'
export const SETTINGS = '/settings'
export const DASHBOARD = '/dashboard'
export const APPLIEDCANDIDATES = '/position-details'
export const COMPANYSETTINGS = '/companysettings'
export const CREATEPOSITIONS = '/createPositions'
export const PREVIEW = '/preview'
export const CUSTOMERRATINGS = '/customerRating'
export const TIMESHEET = '/timesheets'
export const TIMESHEETHISTORY = '/timesheethistory'
export const MAILTIMESHEET = '/timesheet'